<template>
    <v-container>
      <h4>Impressum</h4>
      <v-layout justify-center>
        <v-img src="/img/qwassdxccv.png" max-width="600"></v-img>
      </v-layout>

      <v-row>
        <v-col cols="12">
          <small>
            LastUpdate: {{ lastFetchDate }} 
          </small>
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
export default {
  data: () => ({
    lastFetchDate: null,
  }),
  mounted: function() {
      if (localStorage.currencies) {
        const currencies = JSON.parse(localStorage.currencies);
        this.lastFetchDate = currencies.date;
      }
  },
}
</script>
